module.exports = __webpack_public_path__ + "static/media/33.39d077f3.jpg";